export default __webpack_public_path__ + "static/media/AgencyLandingPage.5ef3ba92.jpeg";